import { useState } from 'react';
import { FORM_SERVICE_TYPE } from '../../constants';
import { IngressEventFormData } from '../../models/index';
import { useSelector } from '../../store/AppStore';
import { isJson } from '../../utilities/services/ServiceEventAssociationUtils';

/**
 * Custom hook to handle Ingress Event Form Inputs
 */
export const useIngressEventForm = () => {
  // Form values
  const [ingressEventFormData, setFormParamValues] = useState(new IngressEventFormData());
  const { serviceType } = useSelector((state) => state.serviceDetailsReducer);

  // A function to handle form inputs
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const key = name as keyof IngressEventFormData;
    if (isJson(value) || value === '' || serviceType?.toLocaleLowerCase() === FORM_SERVICE_TYPE.MQ) {
      setFormParamValues((previousState) => {
        const data = structuredClone(previousState);
        data[key].isValid = true;
        data[key].value = value;
        data[key].isTouched = true;
        data[key].error = '';
        return data;
      });
    } else {
      setFormParamValues((previousState) => {
        const data = structuredClone(previousState);
        data[key].isValid = false;
        data[key].value = value;
        data[key].isTouched = true;
        data[key].error = 'JSON is invalid';
        return data;
      });
    }
  };
  return {
    handleInputChange,
    ingressEventFormData,
    setFormParamValues
  };
};
